<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="楼栋名称" property="buildingName">
									<el-input
										v-model="searchForm.buildingName"
										placeholder="输入楼栋名称"
										clearable
										@keyup.enter.native="getdevices"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="房间号" property="roomNo">
									<el-input
										v-model="searchForm.roomNo"
										placeholder="输入房间号"
										clearable
										@keyup.enter.native="getdevices"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="表号" property="elecNo">
									<el-input
										v-model="searchForm.elecNo"
										placeholder="输入表号"
										clearable
										@keyup.enter.native="getdevices"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="状态" property="onLine">
									<el-select v-model="searchForm.onLine" 
										placeholder="请选择" 
									>
										<el-option
											v-for="item in zaixianOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>	
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="getdevices">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools" style="display: flex;">

							<el-button type="primary" style="margin-left: 10px;" @click="exportExcel">导出</el-button>

							<!-- <el-button type="primary" @click="addHandle">新增</el-button> -->
							<!-- <el-button :disabled="delBtlStatu" type="danger" @click="delHandle()">批量删除</el-button> -->
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column type="index" width="80" align="center" label="编号"></el-table-column>
						<el-table-column prop="roomNo" label="房间" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="elecNo" label="表号" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="startAmount" label="起码" show-overflow-tooltip align="center"></el-table-column> -->
						<!-- <el-table-column prop="startTime" label="起码时间" show-overflow-tooltip align="center"></el-table-column> -->
						<el-table-column prop="lastAmount" label="剩余额度" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="lastTime" label="读表时间" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="onLine" label="电表状态" align="center">
							<template slot-scope="scope">
								<el-tag size="small" style="cursor: pointer;" @click="viewHandle(scope.row, 'lzx')" title="查看离在线记录" type="danger" v-if="scope.row.onLine === 0">离线</el-tag>
								<el-tag size="small" style="cursor: pointer;" @click="viewHandle(scope.row, 'lzx')" title="查看离在线记录" type="primary" v-else>在线</el-tag>
							</template>
						</el-table-column> -->
						<el-table-column prop="overLimit" label="用量告警" align="center">
							<template slot-scope="scope">
								<el-tag size="small" style="cursor: pointer;" @click="viewHandle(scope.row, 'gj')" title="用量告警记录" type="warning" v-if="scope.row.overLimit == 1">超出</el-tag>
								<el-tag size="small" style="cursor: pointer;" @click="viewHandle(scope.row, 'gj')" title="用量告警记录" type="primary" v-else>正常</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  prop="icon"
						  fixed="right"
						  width="200px"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button type="text" v-if="hasAuth('pay:room:electriclist')" @click="viewHandle(scope.row, 'dushu')">读表记录</el-button>
							</template>
						</el-table-column>
					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--对话框-->
		<el-dialog
		  :title="titleDialog"
		  :visible.sync="dialogVisible"
		  width="70%"
		  top="10vh"
		  :before-close="handleClose"
		>
			<el-form class="form-main" size="mini" inline label-width="80px" label-position="right">
				<span>
					<el-form-item label="日期范围" property="dateRange">
						<span>
							<el-date-picker
								v-model="dateRange"
								type="daterange"
								align="right"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								:picker-options="pickerOptions"
								@change="viewHandle"
							/>
						</span>
					</el-form-item>
				</span>
				<div class="search-box-button search-button search_box_button_right">
					<el-button size="mini" type="primary" @click.native.prevent="viewHandle">查 询</el-button>
					<el-button v-if="getParams.type == 'dushu'" size="mini" type="primary" @click.native.prevent="exportExcel('dushu')">导 出</el-button>
				</div>
			</el-form>
		  	<el-table
				ref="multipleTable"
				:data="tableDataDialog"
				tooltip-effect="dark"
				border
				stripe
			>
				<!-- <el-table-column type="index" width="80" align="center" label="编号"></el-table-column> -->

				<span v-if="getParams.type == 'dushu'">
					<el-table-column prop="recordDate" label="读表时间" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="roomNo" label="房间" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="elecNo" label="表号" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="inAmount" label="上次读表数" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="outAmount" label="本次读表数" show-overflow-tooltip align="center"></el-table-column>
					<!-- <el-table-column prop="thisAmount" label="用量（度）" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<span>{{scope.row.thisAmount.toFixed(2)}}</span>
						</template>
					</el-table-column> -->
					
					<!-- <el-table-column prop="lastAmount" label="读表数" show-overflow-tooltip align="center"></el-table-column> -->
				</span>

				<span v-if="getParams.type == 'gj'">
					<el-table-column prop="alarmCount" label="告警次数" show-overflow-tooltip align="center"></el-table-column>

					<el-table-column prop="roomNo" label="房间" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="elecNo" label="表号" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="beginTime" label="告警开始时间" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="endTime" label="告警结束时间" show-overflow-tooltip align="center"></el-table-column>
				</span>
				
				<span v-if="getParams.type == 'lzx'">
					<el-table-column prop="offlineCount" label="离线次数" show-overflow-tooltip align="center"></el-table-column>

					<el-table-column prop="roomNo" label="房间" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="elecNo" label="表号" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="beginTime" label="离线前读表时间" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="createTime" label="记录时间" show-overflow-tooltip align="center"></el-table-column>
				</span>
			</el-table>

			<el-pagination
				@size-change="handleSizeChangeDialog"
				@current-change="handleCurrentChangeDialog"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="currentDialog"
				:page-size="sizeDialog"
				:total="totalDialog">
			</el-pagination>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;text-align: center;">
				<el-button @click="handleClose">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {getDevice, export_excel, getDeviceRecord, exportDeviceRecord, getDeviceOffline, getDeviceAlarm} from '../../apis/devices.js'
export default {
	name: "Electric",	// 电价管理
	data() {
		return {
			nowDate: '',	//导出时当前日期
			loading: true,
			zaixianOptions: [
				{
					value: 0,
					label: '离线'
				},
				{
					value: 1,
					label: '在线'
				}
			],

			searchForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			// 弹窗的数据
			totalDialog: 0,
			sizeDialog: 10,
			currentDialog: 1,
			tableDataDialog: [],
			titleDialog: '记录',
			getParams: {},
			dateRange: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			dialogVisible: false,
			title: '新增',
			editForm: {},

			tableData: [],

			editFormRules: {
				priceName: [
					{required: true, message: '请输入单价名称', trigger: 'blur'}
				],
				price: [
					{required: true, message: '请输入单价', trigger: 'blur'}
				],
				startDate: [
					{required: true, message: '请选择生效日期', trigger: 'change'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.getdevices()
		let t = new Date()
		let t1 = new Date(new Date() - 7 * 24 * 60 * 60 * 1000)
		let start = t1.getFullYear() + '-' + ('0' + (t1.getMonth() + 1)).slice(-2) + '-' + t1.getDate()
		let end = t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + t.getDate()
		this.nowDate = end
		this.dateRange = [start, end]
	},
	methods: {
		resetSearchForm() {
			this.searchForm = {}
			this.getdevices()
		},


		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.getdevices()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getdevices()
		},

		handleSizeChangeDialog(val) {
			this.sizeDialog = val
			this.viewHandle()
		},
		handleCurrentChangeDialog(val) {
			this.currentDialog = val
			this.viewHandle()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.dialogVisible = false
			this.currentDialog = 1
			this.sizeDialog = 10
			this.totalDialog = 0
			this.tableDataDialog = []

			let t = new Date()
			let t1 = new Date(new Date() - 7 * 24 * 60 * 60 * 1000)
			this.dateRange = [t1.getFullYear() + '-' + (t1.getMonth() + 1) + '-' + t1.getDate(), t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()]
		},
		getdevices() {
			const loading = this.$loading({
				text: '加载中...',
			});
			getDevice({current: this.current, size: this.size, ...this.searchForm}).then(res => res.data).then(res => {
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
				loading.close()
			})
		},
		exportExcel(type) {
			const loading = this.$loading({
				text: '加载中...',
			});
			if (type == 'dushu') {
				exportDeviceRecord({elecNo: this.getParams.elecNo, beginDate: this.dateRange[0], endDate: this.dateRange[1]}).then(res => res.data).then(res => {
					loading.close()
					if (res.code == 200) {
						if (res.data.length) {
							let excelData = res.data.map((it, index) => ({index: index + 1,mc: `${it.buildingName}-${it.roomNo}`, bh: it.elecNo, qm: it.inAmount, zm: it.outAmount, zmsj: it.recordDate}))
							this.getExcel(excelData, type)
						} else {
							this.$message({
								type: 'error',
								message: "没有可导数据"
							})
						}
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			} else {
				export_excel({current: this.current, size: this.size, ...this.searchForm}).then(res => res.data).then(res => {
					loading.close()
					if (res.code == 200) {
						if (res.data.length) {
							let excelData = res.data.map((it, index) => ({index: index + 1,mc: `${it.buildingName}-${it.roomNo}`, bh: it.elecNo, zm: it.lastAmount, zmsj: it.lastTime, zt: it.onLine ? '在线' : '离线', updateTime: it.updateTime}))
							this.getExcel(excelData)
						} else {
							this.$message({
								type: 'error',
								message: "没有可导数据"
							})
						}
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}
		},
		getExcel(excelData, type) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new() 

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
			if (type == 'dushu') {
				XLSX.utils.sheet_add_aoa(worksheet, [['序号', '房间', '表号', '上次读表数', '本次读表数', '读表时间']], { origin: 'A1' })
				XLSX.writeFileXLSX(workbook, `电表读表记录${this.nowDate}.xlsx`)
			} else {
				XLSX.utils.sheet_add_aoa(worksheet, [['序号', '房间', '表号', '剩余电量', '读表时间', '状态', '最近更新时间']], { origin: 'A1' })
				XLSX.writeFileXLSX(workbook, `电表列表${this.nowDate}.xlsx`)
			}
        },
		viewHandle(row, rowType) {
			const loading = this.$loading({
				text: '加载中...',
			});

			// console.log(this.dateRange);
			// this.dialogVisible = true
			let elecNo = ""
			let type = ""
			if (row && row.elecNo && rowType) {
				elecNo = row.elecNo
				type = rowType
				let bh = `（${row.buildingName}-${row.roomNo}，表号${elecNo}）`
				this.titleDialog = (rowType == 'dushu' ? '读表记录' : rowType == 'lzx' ? '离线记录' : rowType == 'gj' ? '告警记录' : '记录') + bh
				this.getParams = {
					elecNo: row.elecNo,
					type: rowType
				}
			} else {
				elecNo = this.getParams.elecNo
				type = this.getParams.type
			}

			if (type == 'dushu') {
				getDeviceRecord({current: this.currentDialog, size: this.sizeDialog, elecNo, 
					beginDate: this.dateRange[0], endDate: this.dateRange[1]
				}).then(res => res.data).then(res => {
					// console.log(res);
					loading.close()
					this.dialogVisible = true
					this.tableDataDialog = res.data.records
					this.totalDialog = res.data.total
				})
			} else if (type == 'lzx') {
				getDeviceOffline({
					current: this.currentDialog, size: this.sizeDialog, elecNo,
					beginDate: this.dateRange[0], endDate: this.dateRange[1], offlineCount: 1
					// beginDate: "2024-12-01", endDate: "2024-12-31", offlineCount: 1
				}).then(res => res.data).then(res => {
					loading.close()
					this.dialogVisible = true
					this.tableDataDialog = res.data.records
					this.totalDialog = res.data.total
					// console.log(res);
				})
			} else if (type == 'gj') {
				getDeviceAlarm({
					current: this.currentDialog, size: this.sizeDialog, elecNo,
					beginDate: this.dateRange[0], endDate: this.dateRange[1], alarmCount: 5
					// beginDate: "2024-12-01", endDate: "2024-12-31", alarmCount: 5
				}).then(res => res.data).then(res => {
					loading.close()
					this.dialogVisible = true
					this.tableDataDialog = res.data.records
					this.totalDialog = res.data.total
					// console.log(res);
				})
			}
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// console.log(this.editForm);
					if (this.editForm.id) {
						updateDj({...this.editForm, price: parseFloat(this.editForm.price)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getdevices()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					} else {
						addDj({...this.editForm, price: parseFloat(this.editForm.price)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getdevices()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		addHandle() {
			this.editForm = {}
			this.title = '新增电价'
			this.dialogVisible = true
		},
		editHandle(id) {
			this.title = '编辑电价'
			getdevices1(id).then(res => res.data).then(res => {
				this.editForm = res.data
				this.dialogVisible = true
			})
		},
		delHandle(id) {
			var ids = []
			if (id) {
				ids.push(id)
			} else {
				this.multipleSelection.forEach(row => {
					ids.push(row.id)
				})
			}
			// console.log(ids);
			delDj({ids}).then(res => res.data).then(res => {
				this.$message({
					showClose: true,
					message: '操作成功',
					type: 'success',
					onClose: () => {
						this.multipleSelection = []
						this.delBtlStatu = true
						this.getdevices()
					}
				});
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>